/** Internal dependencies */
import { apiCall } from '../apiCall';
import { getCurrentFilters } from '../getCurrentFilters';
import { resetPagination } from '../resetPagination';

/**
 * Handles interactions with dropdown filters: if necessary adds the filter to the active filters container, then refreshes the view with updated items
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {Event} e
 * @returns false|void
 */
export function handleDropdownFilters(e) {
    e.preventDefault();

    if (!e.target.matches('[type="checkbox"], [type="radio"]')) {
        return false;
    }

    const parent = e.target.closest('[data-ct-rest]');

    // here will come the logic to add the selected filters to the filter status bar
    const activeFiltersContainer = parent.querySelector('[data-ct-filters-active]');

    if (activeFiltersContainer) {
        const filter = e.target;
        const isActive = filter.checked;

        if (isActive) {
            const icon = document.createElement('span');
            icon.classList.add('pill-icon', 'ms-2', 'd-inline-flex', 'align-items-center', 'justify-content-center');
            icon.innerHTML =
                '<svg class="ct-fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"/></svg>';
            const pill = document.createElement('button');
            pill.classList.add(
                'badge',
                'rounded-pill',
                'd-inline-flex',
                'align-items-center',
                'justify-content-center',
                'bg-primary',
                'border-0',
                'mx-2',
                'mt-3'
            );
            pill.setAttribute('type', 'button');
            pill.dataset.ctFilterTaxonomy = filter.name;
            pill.dataset.ctFilterTerm = filter.value;
            pill.textContent = filter.nextElementSibling.textContent;
            pill.appendChild(icon);

            if (filter.type === 'radio') {
                // remove potentially existing pills of same taxonomy
                const existingPill = activeFiltersContainer.querySelector(`[data-ct-filter-taxonomy="${filter.name}"]`);
                if (existingPill) {
                    existingPill.remove();
                }
            }
            activeFiltersContainer.appendChild(pill);
        } else {
            const existingPill = activeFiltersContainer.querySelector(
                `[data-ct-filter-taxonomy="${filter.name}"][data-ct-filter-term="${filter.value}"]`
            );
            if (existingPill) {
                existingPill.remove();
            }
        }
    }

    if (!parent) {
        return;
    }

    resetPagination(parent);
    const currentFilters = getCurrentFilters(parent);
    apiCall(parent, currentFilters, true);
}
